import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import cx from 'classnames2';
import React from 'react';
import styles from './CharacterCounter.scss';
export var CharacterCounter = function CharacterCounter(props) {
  var _classnames;

  var isOverLimit = props.currentCount > props.maxCount;
  var classnames = (_classnames = {}, _defineProperty(_classnames, styles.default, !isOverLimit), _defineProperty(_classnames, styles.error, isOverLimit), _defineProperty(_classnames, styles.alignRight, props.align === 'right'), _defineProperty(_classnames, styles.alignLeft, props.align === 'left'), _classnames);
  return React.createElement("span", {
    className: cx(classnames),
    "data-test": props.dataTest
  }, props.currentCount, "/", props.maxCount);
};
CharacterCounter.defaultProps = {
  align: 'right'
};